import { combineReducers } from 'redux';
import infoReducer from './info/containers/installed-at-info-reducer';

export default combineReducers({
  info: infoReducer,
});
